{
  "page": {
    "title": "Վահանակ",
    "refresh": "Թարմացնել",
    "refreshAriaLabel": "Թարմացնել տվյալները",
    "loading": "Բեռնվում է..."
  },
  "filters": {
    "allEmployees": "Բոլոր աշխատակիցները",
    "employee": "Աշխատակից",
    "timeRange": "Ժամանակահատված",
    "from": "Սկիզբ",
    "to": "Վերջ",
    "ranges": {
      "today": "Այսօր",
      "thisWeek": "Այս շաբաթ",
      "thisMonth": "Այս ամիս",
      "custom": "Կամայական"
    },
    "filteredByCard": "Ֆիլտր՝ {{label}}",
    "employeesShown": "{{count}} աշխատակից",
    "clearFilter": "Մաքրել ֆիլտրը"
  },
  "kpi": {
    "activeEmployees": "Ակտիվ աշխատակիցներ",
    "onSiteNow": "Այս պահին աշխատանքում",
    "onSiteNowHint": "Աշխատակիցներ, ովքեր այսօր մուտք են գրանցել և դեռ ելք չունեն։",
    "totalWork": "Ընդամենը աշխատաժամ",
    "totalBreak": "Ընդամենը ընդմիջում",
    "totalOvertime": "Ընդամենը արտաժամ",
    "totalPayroll": "Ընդամենը աշխատավարձ",
    "lateCount": "Ուշացումներ",
    "absentCount": "Բացակայություններ",
    "punctuality": "Ժամանակին ներկայություն",
    "ofTotal": "{{n}} աշխատակից {{total}}-ից",
    "ofPresent": "{{n}} օր ներկայության {{total}}-ից",
    "failedToLoad": "Չհաջողվեց բեռնել KPI-ի տվյալները:",
    "ariaUpVsPrevious": "Աճ {{value}}% նախորդ ժամանակաշրջանի համեմատ",
    "ariaDownVsPrevious": "Անկում {{value}}% նախորդ ժամանակաշրջանի համեմատ",
    "onLeave": "Արձակուրդում",
    "absent": "Բացակա"
  },
  "charts": {
    "workHoursTrend": "Աշխատաժամերի դինամիկա",
    "punchHeatmap": "Գրանցումների ջերմային քարտ (ժամ)",
    "failedToLoadTrend": "Չհաջողվեց բեռնել դինամիկայի տվյալները:",
    "noTrendData": "Այս ժամանակահատվածի համար դինամիկայի տվյալ չկա:",
    "noPunchData": "Այս ժամանակահատվածի համար գրանցման տվյալ չկա:",
    "heatmapLess": "Քիչ",
    "heatmapMore": "Շատ",
    "days": {
      "mon": "Երկ",
      "tue": "Երք",
      "wed": "Չոր",
      "thu": "Հնգ",
      "fri": "Ուրբ",
      "sat": "Շաբ",
      "sun": "Կիր"
    }
  },
  "workHoursTable": {
    "title": "Ընտրված ժամանակահատվածի աշխատաժամերը",
    "subtitle": "Ամփոփ ընտրված ժամանակաշրջանի համար — սեղմեք տողի վրա՝ աշխատակցի մանրամասները տեսնելու համար:",
    "noData": "Ընտրված ժամանակաշրջանի համար աշխատաժամի տվյալ չկա",
    "noDataHint": "Ճշգրտեք ֆիլտրերը կամ սպասեք սարքի տվյալների համաժամացմանը",
    "noEmployeesInFilter": "Այս ցուցանիշին համապատասխանող աշխատակից չկա",
    "failedToLoad": "Չհաջողվեց բեռնել աշխատաժամի տվյալները: Խնդրում ենք կրկին փորձել:",
    "columns": {
      "employee": "Աշխատակից",
      "days": "Օրեր",
      "work": "Աշխատաժամ",
      "break": "Ընդմիջում",
      "afterHours": "Արտաժամ",
      "lateDeduction": "Ուշացման պահում ({{currency}})",
      "totalPay": "Ընդամենը ({{currency}})"
    }
  },
  "employeePage": {
    "backToDashboard": "Վերադառնալ վահանակ",
    "payslipLabel": "Հաշվաթերթ՝",
    "noProfession": "Մասնագիտությունը նշված չէ",
    "noProfessionHint": "— աշխ. դաշտերը 0 կլինեն: Նշեք դրույքաչափերը «Աշխ.» բաժնում:",
    "workHoursOverTime": "Աշխատաժամերի դինամիկա",
    "noDataForPeriod": "Ընտրված ժամանակաշրջանի համար տվյալ չկա:",
    "dailyBreakdown": "Ամենօրյա մանրամասնում",
    "noDailyRecords": "Այս ժամանակաշրջանում ամենօրյա գրառումներ չկան:",
    "failedToLoad": "Չհաջողվեց բեռնել աշխատակցի տվյալները",
    "failedToLoadHint": "Խնդրում ենք փորձել թարմացնել էջը:",
    "notFound": "Աշխատակիցը չի գտնվել կամ Ձեզ մուտք չի թույլատրված:",
    "columns": {
      "date": "Ամսաթիվ",
      "firstIn": "Առաջին մուտք",
      "lastOut": "Վերջին ելք",
      "work": "Աշխատաժամ",
      "break": "Ընդմիջում",
      "afterHours": "Արտաժամ",
      "punches": "Գրանցումներ",
      "mode": "Ռեժիմ",
      "status": "Կարգավիճակ",
      "hourlyPay": "Ժամային վարձ",
      "afterHoursPay": "Արտաժամ վճար",
      "salaryShare": "Աշխատ. բաժին",
      "lateDeduction": "Ուշացման պահում",
      "totalPay": "Ընդամենը"
    },
    "badges": {
      "statusCodes": "Կարգավիճակի կոդեր",
      "alternating": "Հերթաձև",
      "unpaired": "Անզույգ",
      "downloadPayslip": "Ներբեռնել հաշվաթերթը {{fmt}} ձևաչափով",
      "autoClosed": "Ելքն ավտոմատ լրացվել է աշխատաժամի ավարտին"
    }
  }
}
